import { createContext } from 'react';

import { getDateTimeFormatMapForLang } from '@rover/shared/js/constants/i18n/datetime';

export type DateTimeFormatType = ReturnType<typeof getDateTimeFormatMapForLang>;

export type I18nContextType = {
  DF: DateTimeFormatType;
  locale: string;
};

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export default I18nContext;
